import { ButtonUtils, ObjectBuilder, GridUtils, ImgButton } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
import { text } from "../../TextResources";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { Rectangle } from "@babylonjs/gui/2D/controls/rectangle.js";
export class LobbyModelsPanelContainer {
    constructor(mesh2d, callbacks) {
        this._changingPage = false;
        this._buttonHandlerAsync = async (handler) => {
            if (this._changingPage)
                return;
            this._changingPage = true;
            try {
                await handler();
            }
            finally {
                this._changingPage = false;
            }
        };
        this._mesh2d = mesh2d;
        this._callbacks = callbacks;
        const m = Env.lobby.models;
        const backgroundPanel = new Rectangle("studioModelsBackgroundPanel");
        backgroundPanel.background = m.backgroundPanel.color;
        backgroundPanel.thickness = 0;
        backgroundPanel.cornerRadius = this._mesh2d.m2px(m.backgroundPanel.cornerRadius);
        this._mesh2d.texture.addControl(backgroundPanel);
        const header = ObjectBuilder.createTextBlock3D(this._mesh2d, "studioModelsPanelCaption", text.lobby_models_header, m.header);
        header.textVerticalAlignment = Control.VERTICAL_ALIGNMENT_CENTER;
        backgroundPanel.addControl(header);
        this._stackPanelPage = new StackPanel("studioModelsPage");
        this._stackPanelPage.isVertical = true;
        this._stackPanelPage.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this._stackPanelPage.topInPixels = this._mesh2d.m2px(m.header.height);
        this._stackPanelPage.widthInPixels = this._mesh2d.m2px(m.mesh.width);
        const padding = this._mesh2d.m2px(m.backgroundPanel.padding);
        this._stackPanelPage.paddingLeftInPixels = padding;
        this._stackPanelPage.paddingRightInPixels = padding;
        this._stackPanelPage.paddingTopInPixels = padding;
        this._stackPanelPage.paddingBottomInPixels = padding;
        backgroundPanel.addControl(this._stackPanelPage);
        this._stackPanelPagination = new StackPanel("studioModelsPagination");
        this._stackPanelPagination.isVertical = false;
        this._stackPanelPagination.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
        this._stackPanelPagination.widthInPixels = this._mesh2d.m2px(m.mesh.width);
        this._stackPanelPagination.heightInPixels = this._mesh2d.m2px(m.pagination.height);
        this._stackPanelPagination.leftInPixels = this._mesh2d.m2px(m.pagination.left);
        this._stackPanelPagination.spacing = this._mesh2d.m2px(m.pagination.spacing);
        this._stackPanelPagination.paddingBottomInPixels = this._mesh2d.m2px(m.pagination.padding.bottom);
        backgroundPanel.addControl(this._stackPanelPagination);
        const b = m.pagination.buttons;
        const addPaginationButton = (name, buttonLayout) => {
            const result = new ImgButton(name, buttonLayout);
            result.widthInPixels = this._mesh2d.m2px(b.width);
            result.heightInPixels = this._mesh2d.m2px(b.height);
            return result;
        };
        const firstPageButton = addPaginationButton("studioModelsPaginationFirstPage", b.first);
        firstPageButton.onClickObserver.add(async () => await this._buttonHandlerAsync(callbacks.firstModelsPageAsync));
        this._stackPanelPagination.addControl(firstPageButton);
        const previousPageButton = addPaginationButton("studioModelsPaginationPreviousPage", b.previous);
        previousPageButton.onClickObserver.add(async () => await this._buttonHandlerAsync(callbacks.previousModelsPageAsync));
        this._stackPanelPagination.addControl(previousPageButton);
        const nextPageButton = addPaginationButton("studioModelsPaginationNextPage", b.next);
        nextPageButton.onClickObserver.add(async () => await this._buttonHandlerAsync(callbacks.nextModelsPageAsync));
        this._stackPanelPagination.addControl(nextPageButton);
        const lastPageButton = addPaginationButton("studioModelsPaginationLastPage", b.last);
        lastPageButton.onClickObserver.add(async () => await this._buttonHandlerAsync(callbacks.lastModelsPageAsync));
        this._stackPanelPagination.addControl(lastPageButton);
    }
    updateModelsPage(studioModels) {
        this._stackPanelPage.clearControls();
        const it = Env.lobby.models.item;
        studioModels.pageItems.forEach((studioModel, index) => {
            const itemButton = ButtonUtils.CreateImgButton(`studioModelButton_${index}`, it.buttonLayout, this._mesh2d);
            itemButton.widthInPixels = this._mesh2d.m2px(Env.lobby.models.item.width);
            itemButton.heightInPixels = this._mesh2d.m2px(it.height);
            itemButton.onClickObserver.add(async () => {
                this._callbacks.setGalleryModel(studioModel);
            });
            this._stackPanelPage.addControl(itemButton);
            const itemContainer = GridUtils.CreateGrid(`studioModelButtonSurface_${index}`, it.gridLayout, this._mesh2d);
            itemContainer.widthInPixels = this._mesh2d.m2px(Env.lobby.models.item.width);
            itemContainer.heightInPixels = this._mesh2d.m2px(it.height);
            itemButton.addControl(itemContainer);
            const modelNicknameTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2d, `studioModelNickname_${index}`, `${studioModel.modelNickname}`, it.modelNickname);
            itemContainer.addControl(modelNicknameTextBlock, 0, 0);
            const videosCountTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2d, `studioModelVideosCount_${index}`, `${studioModel.videoClipCount} ${text.lobby_models_videos_label}`, it.videosLabel);
            itemContainer.addControl(videosCountTextBlock, 0, 1);
        });
    }
    updateModelsPageInfo(_pagination) {
        // In case we want to control activity of the pagination buttons.
        // console.log("totalPages:", pagination.totalPages, "currentPageIndex:", pagination.pageIndex);
    }
}
